import { batch, computed, signal } from "@preact/signals-react"

// Table data
export const tableData = signal([])
export const totalCount = signal(0)
export const currentPage = signal(0)
export const pageSize = signal(20)

// Create SKU drawer
export const createSkuDrawer = signal(null)

// Map to existing SKU drawer
export const mapToSkuDrawer = signal(null)

// Image modal
export const imageModal = signal(null)

// Image comparison modal (for SKU vs Raw comparison)
export const imageComparisonModal = signal(null)

// Multiple selection
export const selectedRows = signal([])

// Stats data
export const statsData = signal(null)
export const isLoadingStats = signal(false)

// Loading states
export const isLoadingFilters = signal(false)
export const isLoadingTable = signal(false)

// Filters
export const selectedMarkets = signal([])
export const selectedSites = signal([])   // array of option objects: [{value, label, countryCode}]
export const sitesOptions = signal([])
export const selectedBrands = signal([])
export const selectedBatches = signal([])
export const searchText = signal('')

export const filtersValue = computed(() => ({
    markets: selectedMarkets.value || [],
    sites: (selectedSites.value || []).map(s => s.value),
    brands: selectedBrands.value || [],
    batches: selectedBatches.value || [],
    text: searchText.value || '',
    limit: 20000
}))

export const canSearch = computed(() =>
    selectedMarkets.value.length > 0 || selectedSites.value.length > 0 || selectedBrands.value.length > 0
)

export const clearSkuCandidatesSignals = () => batch(() => {
    tableData.value = []
    totalCount.value = 0
    currentPage.value = 0
    pageSize.value = 20
    isLoadingFilters.value = false
    isLoadingTable.value = false
    selectedMarkets.value = []
    selectedSites.value = []
    selectedBrands.value = []
    selectedBatches.value = []
    searchText.value = ''
    selectedRows.value = []
    statsData.value = null
    createSkuDrawer.value = null
    mapToSkuDrawer.value = null
    imageModal.value = null
    imageComparisonModal.value = null
})
